import React from 'react';
import './CamarasPage.css';

// Datos actualizados con las URLs del servicio de streaming
const camarasData = [
  {
    id: 'CAM-01',
    nombre: 'Peaje Macheta',
    url: 'https://rtsp.me/embed/4F3FE86a/',
  },
  {
    id: 'CAM-02',
    nombre: 'Panoramica',
    url: 'https://rtsp.me/embed/f99KzrBk/', // Reemplazar con ID real
  },
];

const CamarasPage = () => {
  return (
    <div className="camaras-container">
      <h1 className="camaras-title">Visor de Cámaras en Vivo</h1>
      <div className="camaras-grid">
        {camarasData.map((camara) => (
          <div key={camara.id} className="camara-feed">
            {/* Aquí está el cambio principal:
              - Se reemplazó <img> por <iframe>.
              - El 'src' ahora viene de camara.url.
              - Se usan atributos de JSX como 'frameBorder' y 'allowFullScreen'.
              - Se recomienda quitar 'width' y 'height' y controlarlos por CSS para que sea responsivo.
            */}
            <iframe
              src={camara.url}
              className="camara-video" // Usamos la misma clase para aplicar estilos
              title={`Vista de ${camara.nombre}`} // Título dinámico para accesibilidad
              frameBorder="0"
              allowFullScreen
            >
              Tu navegador no soporta iframes.
            </iframe>
            <div className="camara-caption">
              <span className="live-indicator"></span>
              <h4>{camara.nombre}</h4>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CamarasPage;